import axios from 'axios';

export default axios.create({
  //baseURL: 'http://192.168.1.88:8080',
  //baseURL: 'https://192.168.1.88',
  // baseURL: 'https://v.je',
  baseURL: 'https://newback.cldbenevento.com',
});
